import React, { useEffect, useState } from 'react'
import { loginWithOtp, sendOtpToEmailThunk } from '../../store/auth/authThunk';
import { useLocation, useNavigate } from 'react-router';
import DizeeInput from '../../components/DizeeComponent/DizeeInput';
import { useDispatch, useSelector } from 'react-redux';
import Layout from '../../layout';
import { clearAlerts } from '../../store/alert/alertSlice';
import styled from 'styled-components';
import dizeeLogo from "../../assets/images/dizee logo.svg";
import TypeWriter from "../../components/OnBoard/Typewriter";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 350px;
  margin: 0 auto;
  padding-left: 35px;
  padding-top: 0;
`;

const FormSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 80px;
  gap: 2px;
  margin-top: -40px;
  height: 100%;
  position: relative;
  padding-top: 40px;
`;

const ButtonContainer = styled.div`
  height: 40px;
  margin-top: 40px;
  display: flex;
  align-items: center;
  gap: 43px;
`;

const ActionButton = styled.button`
  font-size: 12px;
  color: white;
  cursor: pointer;
  height: 18px;
  line-height: 18px;
  background: transparent;
  border: none;
  padding: 0;
  font-family: inherit;
`;

const Footer = styled.div`
  position: fixed;
  bottom: 27px;
  width: 280px;
`;

const LogoImage = styled.img`
  width: 48px;
  height: auto;
  margin-bottom: 16px;
`;

const FooterText = styled.div`
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  max-width: 280px;
  line-height: 1.5;
`;

export default function Otp() {
    const dispatch = useDispatch();
    const navigation = useNavigate();
    const location = useLocation();

    const [code, setCode] = useState("");
    const [resendTimer, setResendTimer] = useState(0);
    const { email } = location.state || {};
    const { loader } = useSelector((state) => state.alert);
    
    // Send initial email OTP when component mounts
    useEffect(() => {
        if (email) {
            dispatch(clearAlerts());
            dispatch(sendOtpToEmailThunk(email));
        }
    }, [dispatch, email]);

    // Timer countdown for resend
    useEffect(() => {
        if (resendTimer > 0) {
            const timer = setTimeout(() => setResendTimer(prev => prev - 1), 1000);
            return () => clearTimeout(timer);
        }
    }, [resendTimer]);

    const handleConfirm = (e) => {
        e.preventDefault();
        if (code.length === 6 && email) {
            dispatch(clearAlerts());
            dispatch(loginWithOtp({ email, code, phone: "" })).then((res) => {
                if (res.payload.status === 200) {
                    const user = res.payload.data.user;
                    
                    // Smart redirect based on user role
                    if (['manager', 'agent', 'label', 'publisher', 'business-manager'].includes(user.professionRole)) {
                        // Team members go to their dashboard
                        navigation('/team-member-dashboard');
                    } else if (user.professionRole === 'artist') {
                        // Artists go to main interface
                        navigation('/');
                    } else if (user.professionRole === 'personal') {
                        // Personal users go to personal interface
                        navigation('/');
                    } else {
                        // Default fallback
                        navigation('/');
                    }
                }
            });
        }
    };

    const handleResend = () => {
        if (resendTimer > 0 || !email) return;
        
        dispatch(clearAlerts());
        dispatch(sendOtpToEmailThunk(email));
        setResendTimer(30); // Start 30 second cooldown
        setCode(""); // Clear the input field
    };



    return (
        <Layout>
            <Container>
                <FormSection>
                    <TypeWriter 
                        text="Code has been sent to your email" 
                        speed={45} 
                    />
                    <form onSubmit={handleConfirm}>
                        <div className="mb-[68px]">
                            <DizeeInput
                                placeholder={"6-digit code"}
                                onChange={(e) => setCode(e.target.value)}
                                value={code}
                                maxLength={6}
                            />
                        </div>
                        <ButtonContainer>
                            <ActionButton 
                                type="submit"
                                disabled={code.length !== 6 || loader}
                            >
                                Confirm
                            </ActionButton>
                            <ActionButton 
                                type="button" 
                                onClick={handleResend}
                                disabled={resendTimer > 0 || loader}
                            >
                                {resendTimer > 0 ? `Resend in ${resendTimer}s` : 'Resend code'}
                            </ActionButton>
                        </ButtonContainer>
                    </form>
                </FormSection>
                
                <Footer>
                    <LogoImage src={dizeeLogo} alt="DIZEE" />
                    <FooterText>
                        Check your email inbox and spam folder for the verification code.
                    </FooterText>
                </Footer>
            </Container>
        </Layout>
    );
}
